import { ContentfulLivePreviewProvider, useContentfulLiveUpdates } from '@contentful/live-preview/react';
import { useRouter } from 'next/router';

export default function ContentfulLivePreview({ preview, children }) {
	const router = useRouter();

	return (
		<ContentfulLivePreviewProvider
			locale={router.locale ?? 'en-US'}
			enableInspectorMode={preview}
			enableLiveUpdates={preview}
			targetOrigin={['https://app.contentful.com', 'https://app.eu.contentful.com']}
		>
			{children}
		</ContentfulLivePreviewProvider>
	);
}

export function UpdateLivePreviewData<P extends { page?: any }>({
	InternalComponent,
	data,
}: Readonly<{ InternalComponent: React.ComponentType<P>; data: Readonly<P> }>) {
	const { page } = data;
	const pageData = useContentfulLiveUpdates(page);
	return <InternalComponent {...data} page={pageData} />;
}
